export default "__VITE_ASSET__CXDr0XjB__ 40w, __VITE_ASSET__$usy1VTn__ 80w, __VITE_ASSET__B4oACkx$__ 120w";